import { FormStepKey } from "../steps/FormStepKey";

const ZEFFY_EMBED_MESSAGE_PREFIX = "zeffy-embed:";

const buildEmbedMessageKey = (key: string) => `${ZEFFY_EMBED_MESSAGE_PREFIX}${key}`;

const getEmbedId = (): string | null => {
  if (typeof window === "undefined") {
    return null;
  }

  const params = new URLSearchParams(window.location.search);
  return params.get("embedId");
};

const sendEmbedMessage = (key: string, data: object = {}) => {
  if (typeof window === "undefined") {
    return;
  }

  const embedId = getEmbedId();

  window.parent.postMessage({ type: buildEmbedMessageKey(key), embedId, ...data }, "*");
};

export const sendEmbedConnectedMessage = () => sendEmbedMessage("connected");

// Stripe `<Elements>` re-keying fires a burst of ResizeObserver ticks; debounce so the parent
// doesn't animate through every intermediate height (iOS WebKit kills the renderer otherwise).
const RESIZE_DEBOUNCE_MS = 80;
let pendingResizeTimeout: ReturnType<typeof setTimeout> | null = null;
let lastSentHeight: number | null = null;

export const sendEmbedResizedMessage = (height: number) => {
  const measured = Math.ceil(height);
  if (pendingResizeTimeout !== null) {
    clearTimeout(pendingResizeTimeout);
    pendingResizeTimeout = null;
  }
  // A viewport-sized step measures back exactly what the parent applied, so re-sending would add the
  // safety pixel again on every tick and grow the iframe forever.
  if (measured === lastSentHeight) {
    return;
  }
  // Round up and add a safety pixel so display-scaling / zoom rounding
  // doesn't leave the iframe 1 px too short on some monitors.
  const rounded = measured + 1;
  pendingResizeTimeout = setTimeout(() => {
    pendingResizeTimeout = null;
    lastSentHeight = rounded;
    sendEmbedMessage("resized", { height: rounded });
  }, RESIZE_DEBOUNCE_MS);
};

export const sendEmbedStepChangedMessage = (step: FormStepKey) => sendEmbedMessage("step-changed", { step });

export const sendEmbedThankYouAnimationShownMessage = () => sendEmbedMessage("thank-you-animation-shown");

export const sendEmbedLoadingMessage = () => sendEmbedMessage("loading");

export const sendEmbedThankYouPageShownMessage = () => sendEmbedMessage("thank-you-page-shown");
